import React, { useEffect } from "react";
import { Button, Nav, Navbar as NavbarBs } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { ReactComponent as CartLogo } from "../assets/svg/cartActive.svg";
import { ReactComponent as PaymentLogo } from "../assets/svg/paymentInactive.svg";
import { ReactComponent as ThankYouLogo } from "../assets/svg/thankyouInactive.svg";
import { ReactComponent as PaymentActiveLogo } from "../assets/svg/paymentActive.svg";
import { ReactComponent as ThankYouActiveLogo } from "../assets/svg/thankyouActive.svg";
import { useShoppingCart } from "../context/CartContext.tsx/ShoppingCartContext";

export const Navbar = () => {
  const {
    pageData,
    setPageData,
    handleModal,
    modalOpenData,
    closePopup,
    getCartData,
  } = useShoppingCart();
//   console.log(pageData, "satyendra kumar thakur");

  const data = getCartData;
  const cartItemCount = data?.data[0].cart_item_count;
  // <button onClick={props.boxes > 1 ? () => updateCartItem(decreaseQuantity) : undefined}>-</button>

  let currentURL = "";
  // Accessing the URL
  currentURL = window.location.href;
//   console.log(currentURL, "thankyou");
  function retryOrder() {
    // Redirect to the previous URL
    window.history.back();
  }

  return (
    
    <NavbarBs
      sticky="top"
      className="bg-white shadow-sm desktopNav"
      style={{ padding: "8px 15px", zIndex: "999999" }}
    >
   <div className="navContentWrapper">
      {/* <div className="progress-bar1"> */}

      <button
        style={{
          padding: "10px",
          borderRadius: "12px",
        }}
        onClick={() => {
          if (modalOpenData.popupId === "checkout") {
            closePopup();
            setPageData(1);
          } else if (modalOpenData.popupId === "address") {
            closePopup();
            setPageData(1);
          } else if (modalOpenData.popupId === "addressForm") {
            closePopup();
            setPageData(1);
          } else if (modalOpenData.popupId === "coupons") {
            closePopup();
            setPageData(1);
          } else if (currentURL.includes("thankyou")) {
            retryOrder();
            setPageData(1);
          } else if (pageData === 1) {
            window.history.back();
          } else {
            closePopup();
          }
        }}
      >
        <svg
          width="10"
          height="16"
          viewBox="0 0 10 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 15L2 8L9 1"
            stroke="#1B1B1B"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </button>

      <a
        className="header__logo--icon store__logo mobileNone brandLogo"
        href="https://aqualens.in/"
      >
        <img
          src="https://aqualens.in/cdn/shop/files/Aqualens_Logo__308x50_px_1.png?v=1645706435"
          alt="logo"
          style={{
            width: "100px",
          }}
        />
      </a>

      <div
        className={
          pageData > 2
            ? "progress-bar3"
            : pageData > 1
            ? "progress-bar2"
            : "progress-bar1"
        }
      >
        <div className="step_wrapper">
          <div className="step active">
            <p className="step-number">
              <CartLogo />
            </p>
          </div>
          <p className="stepName active">Review Items</p>
        </div>
        <div className="step_wrapper">
          <div className="step">
            <p className="step-number">
              {pageData && pageData > 1 ? (
                <PaymentActiveLogo />
              ) : (
                <PaymentLogo />
              )}
               
            </p>
          </div>

          { pageData && pageData > 1 ? (
          <p className="stepName active">Payment </p>
          ):(
          <p className="stepName InActive">Payment</p>
          )} 
         
        </div>
        <div className="step_wrapper">
          <div className="step">
            <p className="step-number">
              {pageData && pageData > 2 ? (
                <ThankYouActiveLogo />
              ) : (
                <ThankYouLogo />
              )}
            </p>
          </div>
          { pageData && pageData > 2 ? (
          <p className="stepName active">Order Review</p>
          ):(
            <p className="stepName InActive">Order Review</p>

          )}
        </div>
      </div>
      <a
        className="mobileNone ourProducts"
        href="https://aqualens.in/collections/all"
      >
        Our Products
      </a>

      <a
        href="https://api.whatsapp.com/send/?phone=918750888814&amp;text=Hi"
        target="_blank"
      >
        <div className="mobileNone whatsappIcon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21.9803 11.4104C21.6403 5.61044 16.3703 1.14045 10.3003 2.14045C6.12029 2.83045 2.77029 6.22043 2.12029 10.4004C1.74029 12.8204 2.24031 15.1104 3.33031 17.0004L2.4403 20.3104C2.2403 21.0604 2.93028 21.7404 3.67028 21.5304L6.93029 20.6304C8.41029 21.5004 10.1403 22.0004 11.9903 22.0004C17.6303 22.0004 22.3103 17.0304 21.9803 11.4104ZM16.8803 15.7204C16.7903 15.9004 16.6803 16.0704 16.5403 16.2304C16.2903 16.5004 16.0203 16.7004 15.7203 16.8204C15.4203 16.9504 15.0903 17.0104 14.7403 17.0104C14.2303 17.0104 13.6803 16.8905 13.1103 16.6405C12.5303 16.3905 11.9603 16.0604 11.3903 15.6504C10.8103 15.2304 10.2703 14.7604 9.7503 14.2504C9.2303 13.7304 8.77027 13.1804 8.35027 12.6104C7.94027 12.0404 7.61029 11.4704 7.37029 10.9004C7.13029 10.3304 7.01031 9.78045 7.01031 9.26045C7.01031 8.92044 7.0703 8.59044 7.1903 8.29044C7.3103 7.98044 7.50032 7.70045 7.77032 7.45045C8.09032 7.13045 8.4403 6.98045 8.8103 6.98045C8.95029 6.98045 9.09027 7.01044 9.22027 7.07044C9.35027 7.13044 9.47029 7.22044 9.5603 7.35044L10.7203 8.99043C10.8103 9.12043 10.8803 9.23043 10.9203 9.34043C10.9703 9.45043 10.9903 9.55043 10.9903 9.65043C10.9903 9.77043 10.9503 9.89045 10.8803 10.0104C10.8103 10.1304 10.7203 10.2504 10.6003 10.3704L10.2203 10.7704C10.1603 10.8304 10.1403 10.8904 10.1403 10.9704C10.1403 11.0104 10.1503 11.0504 10.1603 11.0904C10.1803 11.1304 10.1903 11.1604 10.2003 11.1904C10.2903 11.3604 10.4503 11.5704 10.6703 11.8304C10.9003 12.0904 11.1403 12.3604 11.4003 12.6204C11.6703 12.8904 11.9303 13.1304 12.2003 13.3604C12.4603 13.5804 12.6803 13.7304 12.8503 13.8204C12.8803 13.8304 12.9103 13.8504 12.9403 13.8604C12.9803 13.8804 13.0203 13.8804 13.0703 13.8804C13.1603 13.8804 13.2203 13.8504 13.2803 13.7904L13.6603 13.4104C13.7903 13.2804 13.9103 13.1904 14.0203 13.1304C14.1403 13.0604 14.2503 13.0204 14.3803 13.0204C14.4803 13.0204 14.5803 13.0404 14.6903 13.0904C14.8003 13.1404 14.9203 13.2004 15.0403 13.2904L16.7003 14.4704C16.8303 14.5604 16.9203 14.6704 16.9803 14.7904C17.0303 14.9204 17.0603 15.0404 17.0603 15.1804C17.0003 15.3504 16.9603 15.5404 16.8803 15.7204Z"
              fill="#666666"
            />
          </svg>
        </div>
      </a>

      <div className="mobileNone cartIcon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.25 22.5C17.2165 22.5 18 21.7165 18 20.75C18 19.7835 17.2165 19 16.25 19C15.2835 19 14.5 19.7835 14.5 20.75C14.5 21.7165 15.2835 22.5 16.25 22.5Z"
            fill="#666666"
          />
          <path
            d="M8.25 22.5C9.2165 22.5 10 21.7165 10 20.75C10 19.7835 9.2165 19 8.25 19C7.2835 19 6.5 19.7835 6.5 20.75C6.5 21.7165 7.2835 22.5 8.25 22.5Z"
            fill="#666666"
          />
          <path
            d="M4.84 3.94L4.64 6.39C4.6 6.86 4.97 7.25 5.44 7.25H20.75C21.17 7.25 21.52 6.93 21.55 6.51C21.68 4.74 20.33 3.3 18.56 3.3H6.27C6.17 2.86 5.97 2.44 5.66 2.09C5.16 1.56 4.46 1.25 3.74 1.25H2C1.59 1.25 1.25 1.59 1.25 2C1.25 2.41 1.59 2.75 2 2.75H3.74C4.05 2.75 4.34 2.88 4.55 3.1C4.76 3.33 4.86 3.63 4.84 3.94Z"
            fill="#666666"
          />
          <path
            d="M20.5101 8.75H5.17005C4.75005 8.75 4.41005 9.07 4.37005 9.48L4.01005 13.83C3.87005 15.54 5.21005 17 6.92005 17H18.0401C19.5401 17 20.8601 15.77 20.9701 14.27L21.3001 9.6C21.3401 9.14 20.9801 8.75 20.5101 8.75Z"
            fill="#666666"
          />
        </svg>
        <span>{cartItemCount}</span>
      </div>
      </div>
    </NavbarBs>
   
   
  );
};
